/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Page_TitleInputs */

const en_negotiation_page_title = /** @type {(inputs: Negotiation_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Framework`)
};

const de_negotiation_page_title = /** @type {(inputs: Negotiation_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Framework`)
};

const fr_negotiation_page_title = /** @type {(inputs: Negotiation_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Framework`)
};

const es_negotiation_page_title = /** @type {(inputs: Negotiation_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Framework`)
};

const it_negotiation_page_title = /** @type {(inputs: Negotiation_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Framework`)
};

const nl_negotiation_page_title = /** @type {(inputs: Negotiation_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Framework`)
};

const pl_negotiation_page_title = /** @type {(inputs: Negotiation_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Framework`)
};

const fi_negotiation_page_title = /** @type {(inputs: Negotiation_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Framework`)
};

const da_negotiation_page_title = /** @type {(inputs: Negotiation_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Framework`)
};

const sv_negotiation_page_title = /** @type {(inputs: Negotiation_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation Framework`)
};

/**
* | output |
* | --- |
* | "Negotiation Framework" |
*
* @param {Negotiation_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_page_title = /** @type {((inputs?: Negotiation_Page_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Page_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_page_title(inputs)
	if (locale === "fr") return fr_negotiation_page_title(inputs)
	if (locale === "es") return es_negotiation_page_title(inputs)
	if (locale === "it") return it_negotiation_page_title(inputs)
	if (locale === "nl") return nl_negotiation_page_title(inputs)
	if (locale === "pl") return pl_negotiation_page_title(inputs)
	if (locale === "fi") return fi_negotiation_page_title(inputs)
	if (locale === "da") return da_negotiation_page_title(inputs)
	if (locale === "sv") return sv_negotiation_page_title(inputs)
	return en_negotiation_page_title(inputs)
});